import { makeApi } from "@zodios/core";
import { z } from "zod";

import { organizationSchema } from "@/types/kili/organizations/organization.type.ts";

export const kiliOrganizationsApi = makeApi([
  {
    method: "get",
    path: "/:organizationId",
    response: organizationSchema,
    alias: "findOrganizationById",
    parameters: [
      {
        type: "Path",
        name: "organizationId",
        schema: z.number(),
      },
    ],
  },
]);
